import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import PropTypes from 'prop-types';

import EventDetailsComponent from '../components/EventDetailsComponent';

import { clearEventData, getEventData } from '../actions';

const EventDetailsContainer = ({ match = {}, eventData }) => {
  const { id } = match.params || {};
  const dispatch = useDispatch();
  const store = useSelector((store) => store);

  const {
    events: { event },
    common,
  } = store;
  const currentUserId = common?.currentUser?.id;

  useEffect(() => {
    !eventData?.id && getEventData(dispatch, id);

    return () => clearEventData(dispatch);
  }, []);

  return (
    <EventDetailsComponent
      event={eventData || event}
      currentUserId={currentUserId}
    />
  );
};

EventDetailsContainer.propTypes = {
  match: PropTypes.instanceOf(Object),
  eventData: PropTypes.instanceOf(Object),
};

export default EventDetailsContainer;
